module.exports = __webpack_public_path__ + "media/images/landing/google_play-bce9b2bc3292b35eb9ecf6e5824b52f4.png";